import { useState, useEffect, useContext } from 'react'
import _ from "lodash"

import Typography from '@mui/material/Typography'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import { searchGooglePlaystore } from '/providers/templates-api'
import { PassContext } from '../pass-context'
import { AppContext } from '/providers/app-context'

const PopupDialogLinkedApp = ({ open, close }) => {

  try {
    const { classData, setClassData, objectData, setObjectData, passType } = useContext(PassContext)
    const { apiSource, apiKey } = useContext(AppContext)

    const [sourceData, setSourceData] = useState({})
    const [appList, setAppList] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [selectedApp, setSelectedApp] = useState()

    useEffect(() => {
      try {
        if (open) {
          if (passType === "generic")
            setSourceData(_.cloneDeep(objectData))
          else
            setSourceData(_.cloneDeep(classData))
        }
      }
      catch (err) {
        throw err
      }
    }, [open])

    const search = async () => {
      try {
        let result = await searchGooglePlaystore({apiSource, apiKey, searchTerm})
        //todo handle error
        setSelectedApp(result.apps[0])
        setAppList(result.apps)
      }
      catch (err) {
        console.error(err)
      }
    }

    const assignSelectedApp = () => {
      let selectedAppEssentialData = {
        androidAppLinkInfo: {
          appTarget: {
            packageName: selectedApp.appId
          }
        },
        displayText: {
          defaultValue: {
            value: selectedApp.title
          }
        },
        seller: selectedApp.developer,
        title: selectedApp.title,
        icon: selectedApp.icon
      }

      let sd = _.cloneDeep(sourceData)
      sd.appLinkData = selectedAppEssentialData
      setSourceData(sd)
    }

    const searchEnterKey = e => {
      if (e.code === "Enter") search()
    }

    const setWebApp = (field, value) => {

      let sd = _.cloneDeep(sourceData)

      if (!sd.appLinkData) sd.appLinkData = {}
      if (!sd.appLinkData.webAppLinkInfo)
        sd.appLinkData.webAppLinkInfo = {
          appTarget: {
            targetUri: {
              uri: "",
              description: ""
            }
          }
        }

      sd.appLinkData.webAppLinkInfo.appTarget.targetUri[field] = value

      setSourceData(sd)
    }

    const removeLinkedNativeApp = () => {
      let sd = _.cloneDeep(sourceData)
      delete sd.appLinkData?.androidAppLinkInfo
      delete sd.appLinkData?.displayText
      setSourceData(sd)
    }

    const removeLinkedWebApp = () => {
      let sd = _.cloneDeep(sourceData)
      delete sd.appLinkData?.webAppLinkInfo
      setSourceData(sd)
    }

    const handleClose = (e, reason) => {
      if (reason && reason === "backdropClick")
        return
      close()
    }

    const save = () => {
      if (passType === "generic") {
        if (!_.isEqual(sourceData,objectData)) setObjectData(sourceData)
      } else {
        if (!_.isEqual(sourceData,classData)) setClassData(sourceData)
      }
      close()
    }

    if (open) return (
      <Dialog onClose={handleClose} open={open} sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "1050px",
            maxWidth: "1050px",
          },
        },
      }}>

        <div className="popupFieldEditor" style={{ width: 1050 }}>

          <Typography variant="h3" sx={{ p: 2 }}>
            Linked Application
          </Typography>

          <Box
            sx={{ '& .MuiTextField-root': { m: 1, width: '420px' } }}
          >

            <div className="flex flex-row gap-5 w-full">
              <div>
                <Typography variant="h6" sx={{ p: 2 }}>
                  Search Apps in Play Store
                </Typography>

                <Typography variant="h6" sx={{ p: 2 }}>
                  Search for an application
                </Typography>

                <div className="flex flex-row justify-between mb-10">
                  <TextField value={searchTerm} onChange={e => setSearchTerm(e.target.value)} onKeyUp={searchEnterKey} />
                  <Button onClick={search} variant="contained" style={{ height: 40, marginTop: 14 }}>Search</Button>
                </div>

                {appList.length > 0 &&
                  <div className="flex flex-row gap-5 mb-10">
                    <div className="flex-grow">
                      <Select
                        value={selectedApp}
                        className="popupEditorMenuItem"
                        onChange={e => setSelectedApp(e.target.value)}>
                        {appList.map(i => <MenuItem key={i.appId} value={i}>
                          <div className="flex flex-row gap-3 mb-5">
                            <img src={i.icon} style={{ height: 60, width: 60 }} />
                            <div className="flex flex-col gap-3">
                              <div>{i.developer}</div>
                              <div>{i.title}</div>
                            </div>
                          </div>
                        </MenuItem>)}
                      </Select>
                    </div>
                    <Button onClick={assignSelectedApp} variant="outlined" sx={{ height: 40 }}>Assign</Button>
                  </div>
                }

              </div>

              <div className="">
                <Typography variant="h6" sx={{ p: 2 }}>
                  Linked Native App
                </Typography>

                <LinkedNativeApp sourceData={sourceData} />

                <Typography variant="h6" sx={{ p: 2 }}>
                  Linked Web App
                </Typography>

                <LinkedWebApp sourceData={sourceData} setWebApp={setWebApp} />
              </div>

            </div>

            <hr />

            <div className="flex flex-row w-full justify-between">
              <div className="flex flex-row gap-5">
                <Button onClick={removeLinkedNativeApp} color="error" variant="outlined">Remove Linked Native App</Button>
                <Button onClick={removeLinkedWebApp} color="error" variant="outlined">Remove Linked Web App</Button>
              </div>

              <div className="flex flex-row-reverse gap-5">
                <Button variant="contained" onClick={save}>Save</Button>
                <Button variant="outlined" onClick={close}>Cancel</Button>
              </div>

            </div>

          </Box>
        </div>
      </Dialog >
    )
  }
  catch (err) {
    console.error(err)
  }
}

export default PopupDialogLinkedApp

const LinkedNativeApp = ({ sourceData }) => {

  if (sourceData.appLinkData?.androidAppLinkInfo) {
    return (
      <div className="flex flex-row gap-3 mb-5 p-4" style={{ width: 420, border: "1px solid black" }}>
        <img src={sourceData.appLinkData.icon} style={{ height: 60, width: 60 }} />
        <div className="flex flex-col gap-3">
          <div>{sourceData.appLinkData.seller}</div>
          <div>{sourceData.appLinkData.title}</div>
          <div>{sourceData.appLinkData.androidAppLinkInfo.appTarget.packageName}</div>
        </div>
      </div>
    )
  } else {
    return <div>No linked native app</div>
  }
}

const LinkedWebApp = ({ sourceData, setWebApp }) => {

  const uri = sourceData.appLinkData?.webAppLinkInfo ? sourceData.appLinkData?.webAppLinkInfo?.appTarget.targetUri.uri : ""
  const description = sourceData.appLinkData?.webAppLinkInfo ? sourceData.appLinkData?.webAppLinkInfo?.appTarget.targetUri.description : ""

  return (
    <>
      <TextField
        label="Web URL"
        value={uri}
        slotProps={{ inputLabel: { shrink: true } }}
        type="search"
        onChange={e => setWebApp("uri", e.target.value)}
      />
      <TextField
        label="Description"
        value={description}
        slotProps={{ inputLabel: { shrink: true } }}
        type="search"
        onChange={e => setWebApp("description", e.target.value)}
      />
    </>
  )
}
